import React from "react";
import {
  FilePdf,
  PencilSimple,
  Printer,
  Receipt,
} from "@phosphor-icons/react";
import { ActionButton } from "../app";

export function QuotationPreviewToolbar({
  quotation,
  t,
  onPrint,
  onExportPdf,
  onEdit,
  onMarkSent,
  onAccept,
  onReject,
  onConvertToInvoice,
}) {
  if (!quotation) return null;

  return (
    <div className="print:hidden sticky top-0 z-10 flex flex-nowrap items-center gap-2 overflow-x-auto border-b border-gray-300 bg-white px-3 py-3 pr-14 shadow-sm sm:flex-wrap sm:gap-3 sm:px-4 sm:pr-16">
      <ActionButton
        icon={Printer}
        label={t("print")}
        tone="default"
        onClick={onPrint}
        className="hidden shrink-0 border-gray-300 sm:inline-flex"
      />

      <ActionButton
        icon={FilePdf}
        label={t("exportPdf")}
        tone="default"
        onClick={onExportPdf}
        className="h-10 w-12 shrink-0 border-gray-300 px-0 sm:w-auto sm:px-4"
      />

      {["borrador", "enviada"].includes(quotation.status) && (
        <>
          <ActionButton
            icon={PencilSimple}
            label={t("edit")}
            tone="primary"
            onClick={onEdit}
            className="h-10 shrink-0 bg-[#E2B05E] px-3 text-[#0B0E14] hover:bg-[#F0C47A] sm:px-4"
          />
          {quotation.status === "borrador" && (
            <ActionButton
              label={t("markAsSent")}
              mobileLabel="Enviar"
              tone="info"
              onClick={onMarkSent}
              className="shrink-0 border-blue-500 bg-blue-500 text-white hover:bg-blue-600"
            />
          )}
        </>
      )}

      {quotation.status === "enviada" && (
        <>
          <ActionButton
            label="Aceptar"
            tone="approve"
            onClick={onAccept}
            className="h-10 min-w-[82px] shrink-0 bg-emerald-500 px-3 text-white hover:bg-emerald-600 sm:min-w-[96px] sm:px-4"
          />
          <ActionButton
            label="Rechazar"
            tone="reject"
            onClick={onReject}
            className="h-10 min-w-[82px] shrink-0 border-red-500 px-3 text-red-500 hover:bg-red-50 sm:min-w-[96px] sm:px-4"
          />
        </>
      )}

      {quotation.status === "aceptada" && (
        <ActionButton
          icon={Receipt}
          label={t("convertToInvoice")}
          mobileLabel="Factura"
          tone="primary"
          onClick={onConvertToInvoice}
          className="shrink-0 bg-[#E2B05E] text-[#0B0E14] hover:bg-[#F0C47A]"
        />
      )}
    </div>
  );
}

export default QuotationPreviewToolbar;
